import $ from 'jquery'
import Swiper from 'swiper/bundle'
import { Fancybox } from '@fancyapps/ui'
import { Modal } from 'bootstrap'

new Swiper('.wide-gallery__slider', {
  slidesPerView: 1.55,
  spaceBetween: 10,
  centeredSlides: true,
  centeredSlidesBounds: true,
  initialSlide: 1,
  loop: true,
  breakpoints: {
    576: {
      slidesPerView: 1,
    },
  },
  navigation: {
    nextEl: null,
    prevEl: null
  },
})

Fancybox.bind('[data-gallery="wide-slider"]', {
  groupAll: true,
  Toolbar: {
    display: {
      left: [],
      middle: [],
      right: ['close'],
    },
  },
  Thumbs: {
    type: 'classic',
  },
})

$('.boat-js-modal__nav button').on('click', function () {
  const $this = $(this)
  const parent = $this.parent()
  const all = $('.boat-js-modal__nav li')
  const pane = $this.attr('data-tab')
  const panes = $('.boat-js-modal__content')

  all.removeClass('active')
  parent.addClass('active')

  panes.removeClass('active')
  $(`[data-pane="${pane}"]`).addClass('active')
})

const modal = document.querySelector('.boat-js-modal')
if (modal) {
  modal.addEventListener('show.bs.modal', (event) => {
    const isPricing = event.relatedTarget.classList.contains(
      'prices-modal-opener'
    )

    const isProperties = event.relatedTarget.classList.contains(
      'properties-modal-opener'
    )

    if (isPricing) {
      $('[data-tab="pricing"]').click()
    }

    if (isProperties) {
      $('[data-tab="properties"]').click()
    }
  })
}

const openFloatingButtons = () => {
  const parent = $('.floating-buttons')
  const buttons = parent.find('.floating-buttons__buttons')
  parent.toggleClass('active')
  buttons.animate({ width: 'toggle' })
}

$('.floating-buttons__opener').on('click', openFloatingButtons)

let opened = false

window.addEventListener('scroll', () => {
  if (opened) {
    return
  }

  if (window.pageYOffset >= 500) {
    openFloatingButtons()
    opened = true
  }
})
